<template>
    <div class="setting-component">
        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <div class="nav-tree">
                    <el-button @click="openModalAdd('create')" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Grouped Item</el-button>
                </div>
                <el-table
                  max-height="650"
                  :data="tableData"
                  style="width: 100%"
                  :empty-text="$t('general_noData')"
                  :header-cell-class-name="headerCellClassName"
                  @row-click="rowClick">
                  <el-table-column
                    label="ID"
                    type="index"
                    width="50">
                  </el-table-column>
                   <el-table-column
                    prop="number"
                    width="120"
                    label="No.">
                  </el-table-column>
                  <el-table-column
                    :label="$t('settings_accountThink_itemsTypes_type')"
                    width="120">
                    <template slot-scope="scope">
                      <span v-if="scope.row.categoryId == 1">{{$t('settings_accountThink_itemsTypes_service')}}</span>
                      <span v-if="scope.row.categoryId == 2">{{$t('settings_accountThink_itemsTypes_nonInventory')}}</span>
                      <span v-if="scope.row.categoryId == 3">{{$t('settings_accountThink_itemsTypes_inventory')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    :label="$t('settings_accountThink_itemsTypes_name')">
                  </el-table-column>
                  <el-table-column
                    width="120"
                    :label="$t('settings_accountThink_itemsTypes_operations')">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="primary"
                        plain
                        icon="el-icon-edit"
                        @click="handleEdit('update', scope.$index, scope.row)"></el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        @click="handleDelete(scope.$index, scope.row)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- add -->
        <sweet-modal blocking title="Add Grouped Item" ref="openModal" class="modal" v-on:close="closeModal" subtitle="tf-Tracking no.: 0000">
          <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
            
            <el-tabs v-model="activeModalTab" style="min-height: 500px;">
                <el-tab-pane name="details" label="Details">
                  <el-row :gutter="20" style="margin-top: 10px;">
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-input label="Item Number" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-input label="Item Name" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-input label="Tag Name" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-select placeholder="Brand" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item style="float: right;">
                        <el-checkbox>Subitem</el-checkbox>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-input placeholder="Item Image" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-select placeholder="Barcode Symbology" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item>
                        <el-select placeholder="This item has multiple Variants" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item>
                        <el-input label="HS / HTS Code" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-select disabled placeholder="Subitem of" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <h4 style="margin-top: 0px;">Notes</h4>
                      <el-form-item>
                        <el-input type="textarea" label="Notes"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>

                <el-tab-pane name="itemGroupList" label="Item Group List">
                  <el-row :gutter="20" style="margin-top: 10px;">
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-input label="Group Name (Tag)" size="normal" clearable></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-input label="Cost of Grouped Items" size="normal" clearable></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-table
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="date"
                      label="Item No."
                      width="160">
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="Item Name">
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="Qty"
                      width="80">
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="Cost"
                      width="120">
                    </el-table-column>
                    <el-table-column
                      prop="address"
                      label="Operation"
                      width="120">
                    </el-table-column>
                  </el-table>
                  
                </el-tab-pane>
                
                <el-tab-pane name="buying" label="Buying">
                  <el-tabs v-model="activeModalTabBuying">
                    <el-tab-pane label="Option 1" name="option1">
                      <el-row :gutter="20" style="margin-top: 10px;">
                        <el-col :span="12" :offset="0">
                          <el-form-item>
                            <el-select placeholder="Vendor" clearable filterable style="width: 100%;">
                              <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item>
                            <el-input label="Vendor Item Code" size="normal" clearable></el-input>
                          </el-form-item>

                          <el-form-item>
                            <el-input label="Buy Price" size="normal" clearable></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12" :offset="0">
                          <el-form-item>
                            <el-select placeholder="Inventory Account" clearable filterable style="width: 100%;">
                              <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          
                          <el-form-item>
                            <el-select placeholder="Tax Type" clearable filterable style="width: 100%;">
                              <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item>
                            <el-select placeholder="Withholding Tax" clearable filterable style="width: 100%;">
                              <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item>
                            <el-select placeholder="Unit Measure" clearable filterable style="width: 100%;">
                              <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="24" :offset="0">
                          <h4 style="margin-top: 0px;">Notes</h4>
                          <el-form-item>
                            <el-input type="textarea" label="Notes"></el-input>
                          </el-form-item>

                          <h4 style="margin-top: 0px;">Notes for Purchase Order</h4>
                          <el-form-item>
                            <vue2-custom-editor
                              ref="editor"/>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="Option 2 (We Buy & Sell This Item)" name="option12">
                      <el-row :gutter="20" style="margin-top: 10px;">
                        <el-col :span="12" :offset="0">
                          <el-form-item>
                            <el-select placeholder="Preferred Vendor" clearable filterable style="width: 100%;">
                              <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item>
                            <el-input label="Vendor Item Code" size="normal" clearable></el-input>
                          </el-form-item>

                          <el-form-item>
                            <el-input label="Buy Price" size="normal" clearable></el-input>
                          </el-form-item>

                          <el-form-item>
                            <el-input label="Vendor Delivery Item" size="normal" clearable></el-input>
                          </el-form-item>

                          <el-form-item>
                            <el-select placeholder="Inventory Account" clearable filterable style="width: 100%;">
                              <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item>
                            <el-select placeholder="Tax Type" clearable filterable style="width: 100%;">
                              <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item>
                            <el-select placeholder="Withholding Tax" clearable filterable style="width: 100%;">
                              <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12" :offset="0">
                          <el-form-item>
                            <el-select placeholder="Unit of Measure" clearable filterable style="width: 100%;">
                              <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item>
                            <el-input label="Gross Weight (kr)" size="normal" clearable></el-input>
                          </el-form-item>

                          <el-form-item>
                            <el-input label="Net Weight (kr)" size="normal" clearable></el-input>
                          </el-form-item>

                          <el-form-item>
                            <el-input label="Packing Type" size="normal" clearable></el-input>
                          </el-form-item>

                          <el-form-item>
                            <el-input placeholder="Add Packing Type Picture" size="normal" clearable></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="24" :offset="0">
                          <h4 style="margin-top: 0px;">Notes</h4>
                          <el-form-item>
                            <el-input type="textarea" label="Notes"></el-input>
                          </el-form-item>

                          <h4 style="margin-top: 0px;">Notes for Purchase Order</h4>
                          <el-form-item>
                            <vue2-custom-editor
                              ref="editor"/>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
                
                <el-tab-pane name="selling" label="Selling">
                  <el-row :gutter="20" style="margin-top: 10px;">
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-input label="Sell Price" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-input label="Calculater Selling Price" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-select placeholder="Sales Account" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item>
                        <el-select placeholder="Cost Account" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item>
                        <el-select placeholder="Inventory Costing Method" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-select placeholder="Tax Type" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item>
                        <el-select placeholder="Withholding Tax" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item>
                        <el-select placeholder="Unit Measure" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <h4 style="margin-top: 0px;">Notes</h4>
                      <el-form-item>
                        <el-input type="textarea" label="Notes"></el-input>
                      </el-form-item>

                      <h4 style="margin-top: 0px;">Notes for Purchase Order</h4>
                      <el-form-item>
                        <vue2-custom-editor
                          ref="editor"/>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <!-- TODO: Notes for Sales Order -->
                </el-tab-pane>
                
                <el-tab-pane name="sorting" label="Sorting">
                  <el-row :gutter="20" style="margin-top: 10px;">
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-input label="Slug" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-select placeholder="Category" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item>
                        <el-select placeholder="Sub Category" clearable filterable style="width: 100%;">
                          <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item>
                        <el-input label="Allow Price Level Categories" size="normal" clearable></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-input label="SKU" size="normal" clearable></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                
                <el-tab-pane name="marketing" label="Marketing">
                  <el-row :gutter="20" style="margin-top: 10px;">
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-input placeholder="Product Gallery Images" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-input label="Hide in Shop Module" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-input label="Featured (Shop homepage listing)" size="normal" clearable></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-checkbox>Create Promotion</el-checkbox>
                      </el-form-item>

                      <el-form-item>
                        <el-input label="Promotion Price" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-date-picker
                          type="date"
                          placeholder="Start Date"
                          style="width: 100%;">
                        </el-date-picker>
                      </el-form-item>

                      <el-form-item>
                        <el-date-picker
                          type="date"
                          placeholder="End Date"
                          style="width: 100%;">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>

                <el-tab-pane name="addInformation" label="Add Information">
                  <el-row :gutter="20" style="margin-top: 10px;">
                    <el-col :span="12" :offset="0">
                      <el-form-item>
                        <el-input label="Item Custom Field 1" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-input label="Item Custom Field 2" size="normal" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-button disabled type="primary" size="normal">Add New Custom Field</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>
            </el-tabs>

            <el-form-item class="modal__btn">
              <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
              <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
            </el-form-item>
          </el-form>
        </sweet-modal>

        <!-- edit -->
        <sweet-modal blocking :title="$t('settings_accountThink_itemsTypes_editItem')" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">
          <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
            <el-form-item>
              <el-select v-model="formEdit.categoryId" :placeholder="$t('settings_accountThink_itemsTypes_category')" style="width: 100%;">
                <el-option v-for="item in formEdit.categoryList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-if="formEdit.categoryId === 3" prop="inventoryItemId">
              <el-select v-model="formEdit.inventoryItemId" :placeholder="$t('settings_accountThink_itemsTypes_inventoryItem')" style="width: 100%;">
                <el-option v-for="item in formEdit.inventoryItemList"
                           :key="item.id"
                           :label="item.warehouseName"
                           :value="item.id">
                  <span style="float: left; color: #8492a6; font-size: 13px">{{ item.warehouseCode }}</span>
                  <span style="float: right">{{ item.warehouseName }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="number">
              <el-input :label="$t('settings_accountThink_itemsTypes_itemNumber')" v-model="formEdit.number"></el-input>
            </el-form-item>

            <el-form-item prop="name">
              <el-input :label="$t('settings_accountThink_itemsTypes_itemName')" v-model="formEdit.name"></el-input>
            </el-form-item>

            <el-form-item prop="description">
              <el-input type="textarea" :placeholder="$t('settings_accountThink_itemsTypes_description')" v-model="formEdit.description"></el-input>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="12">
                <h4>{{$t('settings_accountThink_itemsTypes_sellingDetails')}}</h4>

                <el-form-item prop="sPrice">
                  <el-input :label="$t('settings_accountThink_itemsTypes_sellPrice')" v-model.number="formEdit.sPrice"></el-input>
                </el-form-item>

                <el-form-item prop="sAllocatedTo">
                  <el-select v-model="formEdit.sAllocatedTo" :placeholder="$t('settings_accountThink_itemsTypes_salesAccount')" clearable filterable style="width: 100%;">
                    <el-option v-for="item in formEdit.companyChartOfAccountItemList"
                      :key="item.id"
                      :label="item.groupId + '     ' + item.name"
                      :value="item.id">
                      <span style="float: left; color: #8492a6; font-size: 13px">ID {{ item.groupId }}</span>
                      <span style="float: right">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="sAllocatedTo">
                  <el-select v-model="formEdit.sAllocatedTo2" :placeholder="$t('settings_accountThink_itemsTypes_COGSAccount')" clearable filterable style="width: 100%;">
                    <el-option v-for="item in formEdit.companyChartOfAccountItemList"
                      :key="item.id"
                      :label="item.groupId + '     ' + item.name"
                      :value="item.id">
                      <span style="float: left; color: #8492a6; font-size: 13px">ID {{ item.groupId }}</span>
                      <span style="float: right">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="sTaxType">
                  <el-select v-model="formEdit.sTaxType" :placeholder="$t('settings_accountThink_itemsTypes_taxType')" clearable style="width: 100%;">
                    <el-option v-for="item in formEdit.projectTaxListOutputVAT"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="sWithholdingTax">
                  <el-select v-model="formEdit.sWithholdingTax" :placeholder="$t('settings_accountThink_itemsTypes_withholdingTax')" clearable style="width: 100%;">
                    <el-option v-for="item in formEdit.withholdingTaxList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <h4>{{$t('settings_accountThink_itemsTypes_buyingDetails')}}</h4>

                <el-form-item prop="bVendorId">
                  <el-select v-model="formEdit.bVendorId" :placeholder="$t('settings_accountThink_itemsTypes_vendor')" clearable style="width: 100%;">
                    <el-option v-for="item in formEdit.vendorList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="bPrice">
                  <el-input :label="$t('settings_accountThink_itemsTypes_buyPrice')" v-model="formEdit.bPrice"></el-input>
                </el-form-item>

                <el-form-item prop="bAllocatedTo">
                  <el-select v-model="formEdit.bAllocatedTo" :placeholder="$t('settings_accountThink_itemsTypes_inventoryAccount')" clearable style="width: 100%;">
                    <el-option v-for="item in formEdit.companyChartOfAccountItemList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="bTaxType">
                  <el-select v-model="formEdit.bTaxType" :placeholder="$t('settings_accountThink_itemsTypes_taxType')" clearable style="width: 100%;">
                    <el-option v-for="item in formEdit.projectTaxListInputVAT"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="bWithholdingTax">
                  <el-select v-model="formEdit.bWithholdingTax" :placeholder="$t('settings_accountThink_itemsTypes_withholdingTax')" clearable style="width: 100%;">
                    <el-option v-for="item in formEdit.withholdingTaxList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="vendorItemCode">
                  <el-input :label="$t('settings_accountThink_itemsTypes_vendorItemCode')" v-model="formEdit.vendorItemCode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item prop="unit">
              <el-select v-model="formEdit.unit" :placeholder="$t('settings_accountThink_itemsTypes_unitOfmeasure')" style="width: 100%;">
                <el-option v-for="item in formEdit.unitList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item>
                  <el-input type="textarea" :placeholder="$t('settings_accountThink_itemsTypes_sellingInformation')" v-model="formEdit.sellerDecription"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-input type="textarea" :placeholder="$t('settings_accountThink_itemsTypes_buyingInformation')" v-model="formEdit.buyerDecription"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- <el-form-item prop="unitDescription">
              <el-input type="textarea" placeholder="Unit Description" v-model="formEdit.unitDescription"></el-input>
            </el-form-item> -->

            <el-form-item class="modal__btn">
                <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
                <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
            </el-form-item>
          </el-form>
        </sweet-modal>

        <sweet-modal blocking :title="$t('settings_accountThink_itemsTypes_itemInfo')" ref="infoModal" class="modal">
          <div v-if="infoModal">
            <div :class="{ color: !infoModal.number }"  class="modal__label">
              {{$t('settings_accountThink_itemsTypes_itemNumber')}}: {{infoModal.number}}
            </div>
            <div :class="{ color: !infoModal.name }"  class="modal__label">
              {{$t('settings_accountThink_itemsTypes_itemName')}}: {{infoModal.name}}
            </div>
            <div :class="{ color: !infoModal.description }" class="modal__label">
              {{$t('settings_accountThink_itemsTypes_description')}}: {{infoModal.description}}
            </div>

            <el-row :gutter="20" style="margin-bottom: 20px;">
              <el-col :span="12">
                <h4>{{$t('settings_accountThink_itemsTypes_sellingDetails')}}</h4>

                <div :class="{ color: !infoModal.sellPrice }" class="modal__label">{{$t('settings_accountThink_itemsTypes_price')}}: {{infoModal.sellPrice}}</div>
                <div :class="{ color: !infoModal.sellerCompanyChartOfAccountItem }" class="modal__label">{{$t('settings_accountThink_itemsTypes_allocatedTo')}}: {{infoModal.sellerCompanyChartOfAccountItem}}</div>
                <div :class="{ color: !infoModal.sellerProjectTax }" class="modal__label">{{$t('settings_accountThink_itemsTypes_taxType')}}: {{infoModal.sellerProjectTax}}</div>
                <div :class="{ color: !infoModal.sellerDecription }" class="modal__label">{{$t('settings_accountThink_itemsTypes_sellingInformation')}}: {{infoModal.sellerDecription}}</div>
              </el-col>
              <el-col :span="12">
                <h4>{{$t('settings_accountThink_itemsTypes_buyingDetails')}}</h4>

                <div :class="{ color: !infoModal.buyPrice }" class="modal__label">{{$t('settings_accountThink_itemsTypes_price')}}: {{infoModal.buyPrice}}</div>
                <div :class="{ color: !infoModal.buyerCompanyChartOfAccountItem }" class="modal__label">{{$t('settings_accountThink_itemsTypes_allocatedTo')}}: {{infoModal.buyerCompanyChartOfAccountItem}}</div>
                <div :class="{ color: !infoModal.buyerProjectTax }" class="modal__label">{{$t('settings_accountThink_itemsTypes_taxType')}}: {{infoModal.buyerProjectTax}}</div>
                <div :class="{ color: !infoModal.buyerDecription }" class="modal__label">{{$t('settings_accountThink_itemsTypes_buyingInformation')}}: {{infoModal.buyerDecription}}</div>
              </el-col>
            </el-row>

            <div class="modal__label">{{$t('settings_accountThink_itemsTypes_unit')}}: {{infoModal.unit}}</div>
          </div>
        </sweet-modal>
    </div>
</template>

<script>

  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import Vue2CustomEditor from "../../vue-2-custom-editor";

  export default {
    name: 'company-types',
    components: {
      // AgGridVue,
      SweetModal,
      Vue2CustomEditor,
    },
    data() {
      return {
        activeModalTab: 'details',
        activeModalTabBuying: 'option1',
        serviceIndex: null,
        paleceholderText: this.$i18n.t('settings_accountThink_itemsTypes_invoiceType'),
        btnText: this.$i18n.t('settings_accountThink_itemsTypes_invoiceType'),
        tableData: [],
        selectedRowId: '',
        moment:moment,
        state: 'companyInventoryItems',
        infoModal: {
          number: null,
          name: null,
          description: null,

          // selling
          sellPrice: null,
          sellerCompanyChartOfAccountItem: null,
          sellerProjectTax: null,
          sellerDecription: null,

          // buying
          buyPrice: null,
          buyerCompanyChartOfAccountItem: null,
          buyerProjectTax: null,
          buyerDecription: null,

          unit: null,
        },
        form:{
          categoryId: 1,
          number: null,
          inventoryItemId: '',
          bVendorId: null,
          name: '',
          description: null,

          // selling
          sPrice: null,
          sAllocatedTo: null,
          sAllocatedTo2: null,
          sTaxType: null,
          sInfo: null,
          sellerDecription: null,
          sWithholdingTax: null,

          // buying
          bPrice: null,
          bAllocatedTo: null,
          bTaxType: null,
          buyerDecription: null,
          bWithholdingTax: null,
          vendorItemCode: null,

          categoryList: [{
            label: this.$i18n.t('settings_accountThink_itemsTypes_service'),
            value: 1
          },{
            label: this.$i18n.t('settings_accountThink_itemsTypes_nonInventory'),
            value: 2
          },{
            label: this.$i18n.t('settings_accountThink_itemsTypes_inventory'),
            value: 3
          }],

          unit: null,
          unitList: [],

          projectTaxList: [],
          projectTaxListInputVAT: [],
          projectTaxListOutputVAT: [],
          companyChartOfAccountItemList: [],
          withholdingTaxList: [],
          inventoryItemList: [],
          vendorList:[]
        },
        formEdit:{
          categoryId: 1,
          number: null,
          inventoryItemId: '',
          bVendorId: null,
          name: '',
          description: null,

          // selling
          sPrice: null,
          sAllocatedTo: null,
          sAllocatedTo2: null,
          sTaxType: null,
          sWithholdingTax: null,
          sellerDecription: null,

          // buying
          bPrice: null,
          bAllocatedTo: null,
          bTaxType: null,
          bWithholdingTax: null,
          buyerDecription: null,
          vendorItemCode: null,

          categoryList: [{
            label: this.$i18n.t('settings_accountThink_itemsTypes_service'),
            value: 1
          },{
            label: this.$i18n.t('settings_accountThink_itemsTypes_nonInventory'),
            value: 2
          },{
            label: this.$i18n.t('settings_accountThink_itemsTypes_inventory'),
            value: 3
          }],

          unit: null,
          unitList: [],
          unitDescription: null,

          projectTaxList: [],
          projectTaxListInputVAT: [],
          projectTaxListOutputVAT: [],
          companyChartOfAccountItemList: [],
          inventoryItemList: [],
          vendorList:[]
        },
        rules: {
          number: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],

          unit: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          inventoryItemId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
        },
        rulesEdit: {
          number: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],

          unit: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          inventoryItemId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      loadList(state){
        let loader = this.$loading.show();
        this.state = state
        if(state === 'companyInventoryItems'){
          this.btnText = this.$i18n.t('settings_accountThink_itemsTypes_invoiceType')
          this.paleceholderText = this.$i18n.t('settings_accountThink_itemsTypes_invoiceType')
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            // TODO: splice
            this.tableData.splice(0, 2)
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      openModalAdd(operation, id){
        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios
        //   .post(`/api/v1/${this.state}/directories?companyId=${this.$route.query.companyId}&operation=${operation}`)
        //   .then(response => {
        //     if(operation === 'update'){
        //       this.getItem(id)
        //       this.formEdit.unitList = response.data.units
        //       this.formEdit.projectTaxList = response.data.projectTaxList
        //       this.formEdit.companyChartOfAccountItemList = response.data.companyChartOfAccountItemList
        //       this.formEdit.withholdingTaxList = response.data.withholdingTaxList
        //       this.formEdit.projectTaxListOutputVAT = response.data.projectTaxListOutputVAT
        //       this.formEdit.projectTaxListInputVAT = response.data.projectTaxListInputVAT
        //       this.formEdit.inventoryItemList = response.data.inventory
        //       this.formEdit.vendorList = response.data.companyVendors
        //     }else{
        //       this.form.unitList = response.data.units
        //       this.form.projectTaxList = response.data.projectTaxList
        //       this.form.companyChartOfAccountItemList = response.data.companyChartOfAccountItemList
        //       this.form.withholdingTaxList = response.data.withholdingTaxList
        //       this.form.projectTaxListOutputVAT = response.data.projectTaxListOutputVAT
        //       this.form.projectTaxListInputVAT = response.data.projectTaxListInputVAT
        //       this.form.inventoryItemList = response.data.inventory
        //       this.form.vendorList = response.data.companyVendors
        //       this.$refs.openModal.open()
        //     }
        //   })
        //   .catch(error => {
        //     console.log('An error occurred:', error);
        //   });
        this.$refs.openModal.open()
      },
      getItem(id){
        let loader = this.$loading.show();
        let Id = 'companyInventoryItemId'
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/item?companyId=${this.$route.query.companyId}&${Id}=${id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.categoryId = response.data.item.categoryId
            this.formEdit.number = response.data.item.number
            this.formEdit.number = response.data.item.number
            this.formEdit.name = response.data.item.name
            this.formEdit.inventoryItemId = response.data.item.inventoryId

            // selling
            this.formEdit.sPrice = response.data.item.sellPrice
            this.formEdit.sTaxType = response.data.item.projectTaxId
            this.formEdit.sAllocatedTo = response.data.item.companyChartOfAccountItemId
            this.formEdit.sAllocatedTo = response.data.item.sAllocatedTo2
            this.formEdit.sellerDecription = response.data.item.sellerDecription
            this.formEdit.sWithholdingTax = response.data.item.withholdingTaxId

            // buying
            this.formEdit.bVendorId = response.data.item.vendorId
            this.formEdit.bPrice = response.data.item.buyPrice
            this.formEdit.bTaxType = response.data.item.buyerProjectTaxId
            this.formEdit.bAllocatedTo = response.data.item.buyerCompanyChartOfAccountItemId
            this.formEdit.buyerDecription = response.data.item.buyerDecription
            this.formEdit.bWithholdingTax = response.data.item.buyerWithholdingTaxId
            this.formEdit.vendorItemCode = response.data.item.vendorItemCode

            this.formEdit.unit = response.data.item.unitId

            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      openModalDelete(){

      },
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              categoryId: this.form.categoryId,
              number: this.form.number,
              name: this.form.name,
              description: this.form.description,
              inventoryId: this.form.inventoryItemId || null,

              // selling
              sellPrice: this.form.sPrice,
              projectTaxId: this.form.sTaxType,
              withholdingTaxId: this.form.sWithholdingTax,
              companyChartOfAccountItemId: this.form.sAllocatedTo,
              sAllocatedTo2: this.form.sAllocatedTo2,
              sellerDecription: this.form.sellerDecription,

              // buying
              vendorId: this.form.bVendorId,
              buyPrice: this.form.bPrice,
              buyerProjectTaxId: this.form.bTaxType,
              buyerWithholdingTaxId: this.form.bWithholdingTax,
              buyerCompanyChartOfAccountItemId: this.form.bAllocatedTo,
              buyerDecription: this.form.buyerDecription,
              vendorItemCode: this.form.vendorItemCode || null,

              unitId: this.form.unit,
            }
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${this.state}/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                this.$refs.openModal.close()
                this.loadList(this.state)
                this.notification("Success", "Invoice Type Create", "success");
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      closeModal(){
        this.form.number = null,
        this.form.name = '',
        this.form.description = null,
        this.form.sPrice = null,
        this.form.sAllocatedTo = null,
        this.form.sTaxType = null,
        this.form.sWithholdingTax = null,
        this.form.bPrice = null,
        this.form.bAllocatedTo = null,
        this.form.bTaxType = null,
        this.form.bWithholdingTax = null,
        this.form.unit = null,
        this.form.sellerDecription = null,
        this.form.buyerDecription = null,
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.formEdit.number = null,
        this.formEdit.name = '',
        this.formEdit.description = null,
        this.formEdit.sPrice = null,
        this.formEdit.sAllocatedTo = null,
        this.formEdit.sTaxType = null,
        this.formEdit.sWithholdingTax = null,
        this.formEdit.bPrice = null,
        this.formEdit.bAllocatedTo = null,
        this.formEdit.bTaxType = null,
        this.formEdit.bWithholdingTax = null,
        this.formEdit.unit = null,
        this.formEdit.sellerDecription = null,
        this.formEdit.buyerDecription = null,
        this.$refs['formEdit'].resetFields();
      },
      handleEdit(operation, index, row) {
        console.log(row)
        this.serviceIndex = row.serviceIndex
        this.selectedRowId = row.id
        this.openModalAdd(operation, row.id)
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            let Id = 'companyInventoryItemId'
            let data = {
              categoryId: this.formEdit.categoryId,
              inventoryId: this.formEdit.inventoryItemId || null,
              number: this.formEdit.number,
              name: this.formEdit.name,
              description: this.formEdit.description,

              // selling
              sellPrice: this.formEdit.sPrice,
              projectTaxId: this.formEdit.sTaxType,
              withholdingTaxId: this.formEdit.sWithholdingTax,
              companyChartOfAccountItemId: this.formEdit.sAllocatedTo,
              sAllocatedTo2: this.formEdit.sAllocatedTo2,
              sellerDecription: this.formEdit.sellerDecription,

              // buying
              vendorId: this.formEdit.bVendorId,
              buyPrice: this.formEdit.bPrice,
              buyerProjectTaxId: this.formEdit.bTaxType,
              buyerWithholdingTaxId: this.formEdit.bWithholdingTax,
              buyerCompanyChartOfAccountItemId: this.formEdit.bAllocatedTo,
              buyerDecription: this.formEdit.buyerDecription,
              vendorItemCode: this.formEdit.vendorItemCode || null,

              unitId: this.formEdit.unit,
            }
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${this.state}/update?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`, data)
              .then(response => {
                this.$refs.openModalEdit.close()
                this.loadList(this.state)
                this.notification("Success", "Invoice Type Edit", "success");
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        console.log(row.id)
        // this.$refs.confirmation.open()
        this.selectedRowId = row.id
        console.log(row)

        this.$confirm('This will permanently delete the items. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let Id = 'companyInventoryItemId'
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${this.state}/delete?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`)
            .then(response => {
              // this.$refs.confirmation.close()
              this.loadList(this.state)
              this.notification("Success", "Invoice Item Delete", "success");
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      rowClick(row, column, event){
        this.infoModal.number = row.number || null
        this.infoModal.name = row.name || null
        this.infoModal.description = row.description || null

        this.infoModal.sellPrice = row.sellPrice || null
        if (row.sellerCompanyChartOfAccountItem) this.infoModal.sellerCompanyChartOfAccountItem = row.sellerCompanyChartOfAccountItem.name
        if (row.sellerProjectTax) this.infoModal.sellerProjectTax = row.sellerProjectTax.name
        this.infoModal.sellerDecription = row.sellerDecription || null

        this.infoModal.buyPrice = row.buyPrice || null
        if (row.buyerCompanyChartOfAccountItem) this.infoModal.buyerCompanyChartOfAccountItem = row.buyerCompanyChartOfAccountItem.name
        if (row.buyerProjectTax) this.infoModal.buyerProjectTax = row.buyerProjectTax.name
        this.infoModal.buyerDecription = row.buyerDecription || null

        if (row.unit) this.infoModal.unit = row.unit.name

        console.log('---ROW', row);
        console.log('---column', column);

        if(column.label !== 'Operations') {
          // TODO:
          this.$refs.infoModal.open()
        }
      },
      headerCellClassName({row, column, rowIndex, columnIndex}){
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  /deep/.sweet-modal {
    max-width: 771px !important;
  }
  .setting-component{
    min-width:810px;
  }

  // [ Modal ] start
  .modal {
    &__title {
      text-align: center;
    }
    &__label {
      font-size: 18px;
    }
    &__btn {
      text-align: right;
    }
  }
  // [ Modal ] end

  .color {
    color: #ccc;
  }
</style>
